import { NavMenu } from './NavMenu';
import { Footer } from './Footer';


export function Layout({ children }) {
    return (
        <>
            <NavMenu />
            {children}
            <Footer />
        </>
    )
}
